import { debounce } from 'lodash';
import { QualityTypes } from '@cloudinary/url-gen/types/types';
import { useCallback, useEffect, useState } from 'react';
import { useCloudinary } from './Cloudinary/useCloudinary';
import { useWindowResize } from './Window/useWindowResize';
import { FocusMethod } from '../../../types/CloudinaryImageType';

type Props = {
  imageId?: string;
  initialDimensions?: { width?: number; height?: number };
  quality?: QualityTypes;
  focus?: FocusMethod;
};

export const useResponsiveImage = ({ imageId, initialDimensions, quality = 'auto:good', focus }: Props) => {
  const { getResponsiveImage } = useCloudinary();

  const imageFunction = useCallback(
    (image: string, dimensions?: { width?: number; height?: number }) =>
      dimensions
        ? getResponsiveImage(image, {
            width: dimensions?.width,
            height: dimensions?.height,
            focusMethod: focus,
            quality,
          })
        : getResponsiveImage(image, { quality }),
    [getResponsiveImage, quality, focus],
  );

  const [mainImage, setMainImage] = useState(imageId ? imageFunction(imageId, initialDimensions) : undefined);

  const setResponsiveImage = useCallback(() => {
    if (imageId && setMainImage && imageFunction) {
      setMainImage(imageFunction(imageId));
    }
  }, [imageId, setMainImage, imageFunction]);

  useEffect(() => {
    setResponsiveImage();
  }, [setResponsiveImage]);

  useWindowResize(debounce(() => setResponsiveImage(), 200));

  return mainImage;
};
